export const translation = {
  'nav.home': 'Início',
  'nav.structure': 'Estrutura',
  'nav.modalities': 'Modalidades',
  'nav.plans': 'Planos',
  'nav.store': 'Loja',
  'nav.schedules': 'Horários',
  'nav.location': 'Localização',
  'nav.contact': 'Contato',
  'nav.whatsapp': 'WhatsApp',
  'nav.mainNavigation': 'Navegação principal',
  'nav.openMenu': 'Abrir menu',
  'nav.closeMenu': 'Fechar menu',

  'footer.modalities': 'Modalidades',
  'footer.institutional': 'Institucional',
  'footer.contact': 'Contato',
  'footer.newsletter': 'Receba novidades e horários especiais',
  'footer.newsletterBtn': 'Inscrever',
  'footer.emailPlaceholder': 'Seu e-mail',
  'footer.emailLabel': 'Seu e-mail para receber novidades',
  'footer.rights': 'Todos os direitos reservados',
  'footer.slogan': 'Força de praia, treino de verdade. Cumbuco - CE',
  'footer.description': 'Academia em Cumbuco, Caucaia - CE. Treino de verdade perto da praia.',

  'footer.modalityWeightTraining': 'Musculação',
  'footer.modalityCrossTraining': 'Cross Training',
  'footer.modalityFunctional': 'Circuito Funcional',
  'footer.modalityMuayThai': 'Muay Thai',
  'footer.storeLink': 'Loja Fitness',

  'home.store.marqueeFashion': 'Moda Fitness',
  'home.store.marqueeSupplements': 'Suplementos',
  'home.store.marqueeAccessories': 'Acessórios',
  'home.store.marqueeTraining': 'Treino',
  'home.store.marqueeBodybuilding': 'Musculação',
  'home.store.marqueePerformance': 'Performance',

  'store.category.fashion': 'Moda Fitness',
  'store.category.supplements': 'Suplementos',
  'store.category.accessories': 'Acessórios',

  'store.product.prod-1.name': 'Legging Fitness Premium',
  'store.product.prod-2.name': 'Top Dry-Fit Essential',
  'store.product.prod-3.name': 'Whey Protein 900g',
  'store.product.prod-4.name': 'Creatina Monohidratada 300g',
  'store.product.prod-5.name': 'Garrafa Shaker 700ml',
  'store.product.prod-6.name': 'Tapete de Yoga Premium',
  'store.product.prod-7.name': 'Luvas de Treino',
  'store.product.prod-8.name': 'Camiseta Dry-Fit Masculina',

  'home.hero.videoTitle': 'Top Gym Cumbuco - Treino de verdade perto da praia',
  'home.hero.videoAriaLabel': 'Vídeo da academia Top Gym Cumbuco mostrando estrutura e treinos',

  'structure.musculacao.title': 'Área de Musculação',
  'structure.musculacao.description': 'Equipamentos e pesos livres para treino completo',
  'structure.pesos-livres.title': 'Pesos Livres',
  'structure.pesos-livres.description': 'Halteres, kettlebells, anilhas e barras',
  'structure.cross-training.title': 'Espaço Cross Training',
  'structure.cross-training.description': 'Área para treino funcional e circuito',
  'structure.muay-thai.title': 'Área de Muay Thai e Jiu Jitsu',
  'structure.muay-thai.description': 'Ringue e tatames para treino de lutas',
  'structure.aulas.title': 'Espaço para Aulas',
  'structure.aulas.description': 'Sala para aulas coletivas e funcional',
  'structure.recepcao.title': 'Recepção',
  'structure.recepcao.description': 'Atendimento personalizado e acolhedor',

  'modality.musculacao.name': 'Musculação',
  'modality.musculacao.description': 'Treinos para força, saúde, condicionamento e evolução física com equipamentos e pesos livres.',
  'modality.musculacao.audience': 'Para todos os níveis e objetivos',
  'modality.cross-training.name': 'Cross Training',
  'modality.cross-training.description': 'Treinos variados e intensos que combinam diferentes modalidades para resultado máximo.',
  'modality.cross-training.audience': 'Quem busca desafio e variedade',
  'modality.circuito-funcional.name': 'Circuito Funcional',
  'modality.circuito-funcional.description': 'Aulas dinâmicas com movimentos naturais que melhoram resistência, agilidade e coordenação.',
  'modality.circuito-funcional.audience': 'Ideal para condicionamento geral',
  'modality.muay-thai.name': 'Muay Thai e Jiu Jitsu',
  'modality.muay-thai.description': 'Artes marciais que desenvolvem técnica, condicionamento físico, defesa pessoal e autoconfiança.',
  'modality.muay-thai.audience': 'Para iniciantes e praticantes de ambas modalidades',

  'testimonial.carlos.name': 'Carlos M.',
  'testimonial.carlos.location': 'Cumbuco, CE',
  'testimonial.carlos.text': 'Equipamentos bons, ambiente de comunidade e equipe qualificada. A academia completa para o tamanho da vila.',
  'testimonial.ana.name': 'Ana Paula R.',
  'testimonial.ana.location': 'Caucaia, CE',
  'testimonial.ana.text': 'Estou treinando há 6 meses e a evolução é notável. Professores atenciosos e equipamentos de qualidade.',
  'testimonial.pedro.name': 'Pedro S.',
  'testimonial.pedro.location': 'Fortaleza, CE',
  'testimonial.pedro.text': 'Passo temporada em Cumbuco e a Top Gym é meu ponto de parada obrigatório. Ótima estrutura perto da praia.',

  'cta.whatsapp': 'Chamar no WhatsApp',
  'cta.map': 'Ver localização',
  'cta.seeMore': 'Ver mais',
  'cta.knowMore': 'Conhecer',
  'cta.heading': 'FALE COM A TOP GYM',

  'mobile.whatsapp': 'WhatsApp',
  'mobile.directions': 'Como chegar',

  'page.estrutura.title': 'ESTRUTURA',
  'page.estrutura.highlight': 'COMPLETA',
  'page.estrutura.subtitle': 'Conheça nossa estrutura pensada para todos os tipos de treino.',

  'page.modalidades.title': 'MODALIDADES',
  'page.modalidades.subtitle': 'Musculação, cross training, circuito funcional e muay thai para todos os níveis.',
  'page.modalidades.tag': 'Mais Popular',

  'page.horarios.title': 'HORÁRIOS',
  'page.horarios.subtitle': 'Funcionamento e aulas para planejar seu treino.',
  'page.horarios.weekday': 'Segunda a Sexta',
  'page.horarios.weekdayHours': '06h às 22h',
  'page.horarios.saturday': 'Sábado',
  'page.horarios.saturdayHours': '08h às 12h',
  'page.horarios.sunday': 'Domingo',
  'page.horarios.sundayHours': 'Fechado',
  'page.horarios.classSchedule': 'Grade de Aulas',

  'page.localizacao.title': 'LOCALIZAÇÃO',
  'page.localizacao.subtitle': 'Venha treinar conosco em Cumbuco, a poucos minutos da praia.',
  'page.localizacao.addressLabel': 'Endereço',
  'page.localizacao.referenceLabel': 'Referência',
  'page.localizacao.referenceText': 'Fica em Cumbuco, a poucos minutos da praia',
  'page.localizacao.openMap': 'Abrir no Google Maps',

  'page.contato.title': 'CONTATO',
  'page.contato.subtitle': 'Fale com a Top Gym e veja planos, horários e modalidades disponíveis.',
  'page.contato.contactUs': 'Fale Conosco',
  'page.contato.whatsapp': 'WhatsApp',
  'page.contato.email': 'E-mail',
  'page.contato.address': 'Endereço',
  'page.contato.instagram': 'Instagram',
  'page.contato.hours': 'Horários',
  'page.contato.weekday': 'Seg-Sex:',
  'page.contato.saturday': 'Sábado:',
  'page.contato.sunday': 'Domingo:',
  'page.contato.formTitle': 'Quero falar com a Top Gym',
  'page.contato.formSubtitle': 'Preencha seus dados e entraremos em contato.',
  'page.contato.name': 'Nome',
  'page.contato.namePlaceholder': 'Seu nome',
  'page.contato.phone': 'Telefone',
  'page.contato.phonePlaceholder': '(85) 99999-9999',
  'page.contato.goal': 'Objetivo',
  'page.contato.goalPlaceholder': 'Conte seu objetivo...',
  'page.contato.submit': 'Quero falar com a Top Gym',
  'page.contato.sentTitle': 'WhatsApp aberto!',
  'page.contato.sentText': 'Revise a mensagem no WhatsApp e toque em Enviar.',
  'page.contato.sentBtn': 'WhatsApp aberto! Revise e envie a mensagem.',
  'page.contato.qrTitle': 'Fale no WhatsApp',
  'page.contato.qrSubtitle': 'Aponte a câmera do celular',

  'seo.home.title': 'Top Gym - Academia Premium em Cumbuco',
  'seo.home.description': 'A Top Gym Cumbuco é uma academia para quem quer treinar com estrutura, orientação e energia internacional. Seja você morador, visitante ou alguém passando uma temporada em Cumbuco, aqui o treino continua.',
  'seo.home.keywords': 'academia, fitness, musculação, malhar, treinar em Cumbuco',

  'seo.estrutura.title': 'Estrutura da Top Gym Cumbuco',
  'seo.estrutura.description': 'Conheça a estrutura completa da Top Gym Cumbuco. Equipamentos modernos, espaço para musculação, funcional e artes marciais.',
  'seo.estrutura.keywords': 'academia, musculação, funcional, artes marciais, fitness, treino',

  'seo.modalidades.title': 'Modalidades de Treino na Top Gym Cumbuco',
  'seo.modalidades.description': 'Musculação, cross training, circuito funcional e muay thai. Treinos para todos os níveis na Top Gym Cumbuco.',
  'seo.modalidades.keywords': 'academia, musculação, funcional, artes marciais, fitness, treino',

  'seo.horarios.title': 'Horários de Aulas e Funcionamento - Top Gym Cumbuco',
  'seo.horarios.description': 'Horários de funcionamento e grade de aulas da Top Gym Cumbuco. Planeje seu treino de segunda a sábado.',
  'seo.horarios.keywords': 'academia, horários, aulas, musculação, fitness, treino',

  'seo.localizacao.title': 'Localização da Top Gym Cumbuco - Cumbuco, Caucaia',
  'seo.localizacao.description': 'Venha treinar conosco em Cumbuco, a poucos minutos da praia. Endereço e como chegar na Top Gym Cumbuco.',
  'seo.localizacao.keywords': 'academia Cumbuco, academia Caucaia, musculação Cumbuco, fitness Ceará',

  'seo.contato.title': 'Contato da Top Gym Cumbuco - Fale Conosco',
  'seo.contato.description': 'Entre em contato com a Top Gym Cumbuco. Tire dúvidas sobre planos, horários e modalidades.',
  'seo.contato.keywords': 'academia, contato, WhatsApp, musculação, fitness, treino',

  'page.notFound.documentTitle': 'Página não encontrada | Top Gym Cumbuco',
  'page.notFound.heading': 'Página não encontrada',
  'page.notFound.backBtn': 'Voltar para o início',
};
